import { render, staticRenderFns } from "./TruckReleaseDetail.vue?vue&type=template&id=2545b0c0&scoped=true&"
import script from "./TruckReleaseDetail.vue?vue&type=script&lang=js&"
export * from "./TruckReleaseDetail.vue?vue&type=script&lang=js&"
import style0 from "./TruckReleaseDetail.vue?vue&type=style&index=0&id=2545b0c0&scoped=true&lang=less&"
import style1 from "./TruckReleaseDetail.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2545b0c0",
  null
  
)

export default component.exports